import { render } from "./slidesdb_chap01_en.vue?vue&type=template&id=3595f6dd&scoped=true"
import script from "./slidesdb_chap01_en.vue?vue&type=script&lang=js"
export * from "./slidesdb_chap01_en.vue?vue&type=script&lang=js"

import "@/assets/css/globalen.css?vue&type=style&index=0&id=3595f6dd&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3595f6dd"]])

export default __exports__